<template>
  <div class="account-user">
    <common-layout>
      <div slot="header">
        <h3>网站注册用户管理</h3>
      </div>
      <div slot="container">
        <div class="account-user.header">
          <section>
            <el-input
              placeholder="请输入用户名"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @clear="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
            <label style="margin:0 15px;">注册平台：</label>
            <el-select
              style="width: 140px"
              v-model="srelease"
              clearable
              placeholder="全部"
              @change="search"
            >
              <el-option
                v-for="item in sourcerelease"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </section>
        </div>
        <div class="account-user.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="用户名"
              align="center"
            ></el-table-column>
            <el-table-column prop="password" label="登录密码" align="center">
              <template slot-scope="scope">{{
                scope.row.password
                  ? scope.row.password.substring(0, 2) +
                    "****" +
                    scope.row.password.substring(
                      scope.row.password.length - 1,
                      scope.row.password.length
                    )
                  : ""
              }}</template>
            </el-table-column>
            <el-table-column label="注册平台" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.is_market === 2 && scope.row.is_achievement === 2">后台新增</span>
                <span v-if="scope.row.is_market === 1 && scope.row.is_achievement === 2">
                  大市场平台
                </span>
                <span v-if="scope.row.is_market === 2 && scope.row.is_achievement === 1">
                  成果交易平台
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="手机号"
              align="center"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              align="center"
              prop="register_time"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openModal(scope.row.id)"
                  >个人详情</el-button
                >
                <el-button
                  type="warning"
                  plain
                  size="mini"
                  @click="openAffirm(scope.row.id)"
                  >认证详情</el-button
                >
                <el-button
                  type="success"
                  plain
                  size="mini"
                  @click="openFixed(scope.row.id)"
                  >账号绑定</el-button
                >
                <el-button
                  type="danger"
                  plain
                  size="mini"
                  @click="unFixed(scope.row.id)"
                  v-if="scope.row.user_bind_unit_id"
                  >账号解绑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <div class="grid-content bg-purple-light">
              <el-pagination
                @current-change="handleCurrentChange"
                :hide-on-single-page="true"
                layout="total, prev, pager, next,jumper"
                :total="total"
                :current-page.sync="current_page"
                :page-size="per_page"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="用户详情"
      :visible.sync="dialogFormVisible"
      width="35%"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户头像" :label-width="formLabelWidth">
              <img
                :src="imgUrl + form.image"
                class="avatar-uploader"
                v-if="form.image"
              />
              <img
                v-else
                src="../../assets/user/user.jpg"
                class="avatar-uploader"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" :label-width="formLabelWidth">
              <el-input
                v-model="form.username"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录密码" :label-width="formLabelWidth">
              <el-input
                v-model="form.password"
                autocomplete="off"
                show-password
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号" :label-width="formLabelWidth">
              <el-input
                v-model="form.phone || '暂无'"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间" :label-width="formLabelWidth">
              <el-input
                v-model="form.register_time || '暂无'"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮箱" :label-width="formLabelWidth">
              <el-input
                v-model="form.mail || '暂无'"
                autocomplete="off"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input
                v-model="form.remark || '暂无'"
                autocomplete="off"
                type="textarea"
                :rows="5"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="titleB"
      :visible.sync="dialogFormVisibleB"
      width="35%"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="成果来源" :label-width="formLabelWidth">
              <el-cascader
                :props="cascaderProps"
                :options="optionsTree"
                clearable
                v-model="resource"
                @change="handChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer bind">
        <el-button type="primary" @click="confirmFun">确定</el-button>
        <el-button type="primary" @click="closeFun">关闭</el-button>
        <!-- <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      searchValue: "",
      tableData: [],
      total: 20,
      current_page: 1,
      per_page: 10,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      form: {
        image: "",
        mail: "",
        password: "",
        phone: "",
        register_time: "",
        remark: "",
        username: "",
      },
      titleB: "",
      dialogFormVisibleB: false,
      optionsTree: [],
      options: [
        {
          value: "001",
          label: "技术转移中心",
          children: [
            {
              value: "0011",
              label: "张江兰白创新改革试验区技术转移中心",
            },
            {
              value: "0012",
              label: "北京大学技术转移甘肃中心",
            },
            {
              value: "0013",
              label: "中国科学技术大学技术转移甘肃中心",
            },
            {
              value: "0014",
              label: "国家技术转移东部中心",
            },
            {
              value: "0015",
              label: "瑞士洛桑大学技术转移中心",
            },
            {
              value: "0016",
              label: "新加坡南洋理工大学技术转移中心",
            },
          ],
        },
        {
          value: "002",
          label: "一院三所",
          children: [
            {
              value: "0021",
              label: "中国科学院兰州化学物理研究所",
            },
            {
              value: "0022",
              label: "中国科学院近代物理研究所",
            },
            {
              value: "0023",
              label: "中国科学院寒区旱区环境与工程研究所",
            },
          ],
        },
        {
          value: "003",
          label: "在甘院校",
          children: [
            {
              value: "0031",
              label: "高等院校",
              children: [
                {
                  value: "00311",
                  label: "兰州大学",
                },
                {
                  value: "00312",
                  label: "兰州理工大学",
                },
                {
                  value: "00313",
                  label: "兰州交通大学",
                },
                {
                  value: "00314",
                  label: "西北名族大学",
                },
                {
                  value: "00315",
                  label: "甘肃农业大学",
                },
                {
                  value: "00316",
                  label: "兰州城市学院",
                },
                {
                  value: "00317",
                  label: "西北师范大学",
                },
                {
                  value: "00318",
                  label: "河西学院",
                },
                {
                  value: "00319",
                  label: "陇东学院",
                },
              ],
            },
            {
              value: "0032",
              label: "科研院所",
              children: [
                {
                  value: "00321",
                  label: "甘肃省科学院",
                },
                {
                  value: "00322",
                  label: "甘肃省农业科学院",
                },
                {
                  value: "00323",
                  label: "甘肃省膜科学技术研究院有限公司",
                },
                {
                  value: "00324",
                  label: "甘肃省科学院生物研究所",
                },
                {
                  value: "00325",
                  label: "甘肃省商业科技研究所",
                },
                {
                  value: "00326",
                  label: "甘肃省建材科研设计院",
                },
              ],
            },
          ],
        },
        {
          value: "004",
          label: "省属企业",
        },
        {
          value: "005",
          label: "省外合作单位",
        },
        {
          value: "006",
          label: "研发机构",
          children: [
            {
              value: "0061",
              label: "兰州大学白银产业技术研究院",
            },
            {
              value: "0062",
              label: "兰州理工大学白银新材料研究院",
            },
            {
              value: "0063",
              label: "甘肃西部凹凸棒石应用研究院",
            },
            {
              value: "0064",
              label: "白银市东西部协同创新研究院",
            },
            {
              value: "0065",
              label: "甘肃省陇杞中药研究院",
            },
            {
              value: "0066",
              label: "白银市实创高新产业研究院",
            },
          ],
        },
        {
          value: "007",
          label: "个人",
        },
      ],
      resource: [],
      srelease: '',
      sourcerelease: [
        {
          value: 1,
          label: '后台新增',
        },
        {
          value: 2,
          label: '大市场平台',
        },
        {
          value: 3,
          label: '成果交易平台',
        },
      ],
      operateUserId: "",
      cascaderProps: {
        value: "id",
        label: "name",
        children: "sub",
      },
    };
  },
  methods: {
    // 获取树
    async getTreeJson() {
      let res = await this.http.get("/Unit?all_sub=1");
      if (res.code == 0) {
        this.optionsTree = res.data.data.tree;
      }
      console.log("获取树", this.optionsTree);
    },

    search() {
      this.getData(
        `User?username=${this.searchValue}` +
          (this.srelease
            ? this.srelease === 1
              ? '&is_market=2&is_achievement=2'
              : this.srelease === 2
              ? '&is_market=1&is_achievement=2'
              : '&is_market=2&is_achievement=1'
            : '')
      );
    },
    //获取数据
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.current_page = res.data.current_page;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
        }
      });
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;
      // this.getData(`User?type=1&page=${this.current_page}`);
      this.getData(`User?page=${this.current_page}`);
    },
    openModal(id) {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/system/user/${id}`).then((res) => {
        this.form = res.data;
        this.dialogFormVisible = true;
      });
    },
    openAffirm(id) {
      this.$router.push("/user/affirm/" + id);
    },
    openFixed(id) {
      this.resource = [];
      this.operateUserId = id;
      this.dialogFormVisibleB = true;
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/system/user/${id}`).then((res) => {
        if (res.code == 0) {
          this.resource = res.data.user_bind_unit_json
            ? JSON.parse(res.data.user_bind_unit_json)
            : null;
        }
      });
    },
    unFixed(id) {
      this.$confirm("确定解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let pam = {
            user_bind_unit_id: null,
            user_bind_unit_json: null,
          };
          this.http.put(`${urlConfig.devUrl}apij2/admin-api/system/user/unbind/` + id, pam).then((response) => {
            if (response.code == 0) {
              this.$message.success("解绑成功！");

              this.getData(`User`);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑",
          });
        });
    },
    handChange(e) {
      console.log("三级联动", e);
    },
    closeFun() {
      this.dialogFormVisibleB = false;
    },
    async confirmFun() {
      if (this.resource.length) {
        console.log("选择结果", this.resource);
        let pam = {
          user_bind_unit_id: this.resource[this.resource.length - 1],
          user_bind_unit_json: JSON.stringify(this.resource),
        };
        let res = await this.http.put(`${urlConfig.devUrl}apij2/admin-api/system/user/${this.operateUserId}`, pam);
        if (res.code == 0) {
          this.$message.success("绑定成功");

          this.dialogFormVisibleB = false;
          this.getData(`User`);
        } else {
          this.$message.error(res.status);
        }
      } else {
        this.$message.warning("请选择成果来源");
      }
    },
  },
  created() {
    // this.getData(`User?type=1`)
    this.getTreeJson();
    this.getData(`User`);
  },
};
</script>
<style lang="scss">
@include component(account-user) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }
  @include part(table) {
    margin-top: 30px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-cascader {
    width: 100% !important;
  }
  .bind {
    text-align: center;
  }
}
</style>
